// src/app/redux/reducers/modeEvaluationReducer.js

import {
    FETCH_MODES_EVALUATION_REQUEST, FETCH_MODES_EVALUATION_SUCCESS, FETCH_MODES_EVALUATION_FAIL,
    CREATE_MODE_EVALUATION_REQUEST, CREATE_MODE_EVALUATION_SUCCESS, CREATE_MODE_EVALUATION_FAIL,
    UPDATE_MODE_EVALUATION_REQUEST, UPDATE_MODE_EVALUATION_SUCCESS, UPDATE_MODE_EVALUATION_FAIL,
    DELETE_MODE_EVALUATION_REQUEST, DELETE_MODE_EVALUATION_SUCCESS, DELETE_MODE_EVALUATION_FAIL,
    SET_MODE_EVALUATION_LOADING, CLEAR_MODE_EVALUATION_ERROR,
} from "../actions/modeEvaluationActions";

const initialState = {
    modesEvaluation: [],
    loading: false,
    error: null,
};

export default function modeEvaluationReducer(state = initialState, action) {
    switch (action.type) {

        case SET_MODE_EVALUATION_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_MODE_EVALUATION_ERROR:
            return { ...state, error: null };

        case FETCH_MODES_EVALUATION_REQUEST:
        case CREATE_MODE_EVALUATION_REQUEST:
        case UPDATE_MODE_EVALUATION_REQUEST:
        case DELETE_MODE_EVALUATION_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_MODES_EVALUATION_SUCCESS:
            return { ...state, loading: false, modesEvaluation: action.payload || [] };

        case CREATE_MODE_EVALUATION_SUCCESS:
            return { ...state, loading: false, modesEvaluation: [...state.modesEvaluation, action.payload] };

        case UPDATE_MODE_EVALUATION_SUCCESS:
            return {
                ...state,
                loading: false,
                modesEvaluation: state.modesEvaluation.map((m) =>
                    m.id === action.payload.id ? action.payload : m
                ),
            };

        case DELETE_MODE_EVALUATION_SUCCESS:
            return {
                ...state,
                loading: false,
                modesEvaluation: state.modesEvaluation.filter((m) => m.id !== action.payload.id),
            };

        case FETCH_MODES_EVALUATION_FAIL:
        case CREATE_MODE_EVALUATION_FAIL:
        case UPDATE_MODE_EVALUATION_FAIL:
        case DELETE_MODE_EVALUATION_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}